import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

//template
import TemplateRoute from './template-route';

//components
import AppLoader from '../components/loader';

//pages
import Login from '../pages/login';
import Banner from '../pages/banner';
import UserManagement from '../pages/user';
import LiveChat from '../pages/live-chat';
import HighlightBox from '../pages/highlight-box';
import MainContent from '../pages/main-content';
import News from '../pages/news';
import ServiceLink from '../pages/service-link';
import Notification from '../pages/notification';
import Activity from '../pages/activity';
import TemplateContent from '../pages/template-content';
import Menu from '../pages/menu';
import Photo from '../pages/gallery/photo';
import Video from '../pages/gallery/video';
import Document from '../pages/gallery/document';
import ForgotPassword from '../pages/forgot-password';
import ResetPassword from '../pages/reset-password';
import Profile from '../pages/profile';
import FooterLink from '../pages/footer-link';

const AppRouteContainer = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path="/" component={Login} />
                <TemplateRoute exact path="/user-management" component={UserManagement} />
                <TemplateRoute exact path="/live-chat" component={LiveChat} />
                <TemplateRoute exact path="/banner" component={Banner} />
                <TemplateRoute exact path="/highlight-box" component={HighlightBox} />
                <TemplateRoute exact path="/main-content" component={MainContent} />
                <TemplateRoute exact path="/news" component={News} />
                <TemplateRoute exact path="/service-link" component={ServiceLink} />
                <TemplateRoute exact path="/footer-link" component={FooterLink} />
                <TemplateRoute exact path="/notification" component={Notification} />
                <TemplateRoute exact path="/activity" component={Activity} />
                <TemplateRoute exact path="/template-content" component={TemplateContent} />
                <TemplateRoute exact path="/menu" component={Menu} />
                <TemplateRoute exact path="/gallery/photo" component={Photo} />
                <TemplateRoute exact path="/gallery/video" component={Video} />
                <TemplateRoute exact path="/gallery/document" component={Document} />
                <TemplateRoute exact path="/profile" component={Profile} />
                <Route exact path="/forgotPassword" component={ForgotPassword} />
                <Route exact path="/user/resetPassword/:token" component={ResetPassword} />
            </Switch>
            <AppLoader />
        </BrowserRouter>
    )
}

export default AppRouteContainer;